module.exports = __webpack_public_path__ + "img/logo.27294e54.png";